import React from 'react';

interface FilterQueryFormProps {

}

const FilterQueryForm: React.FC<FilterQueryFormProps> = () => {

    return (
        <div>
            <h3>More Filters</h3>

        </div>
    );
};

export default FilterQueryForm;